// frontend/src/features/bapb/sections/IncomeAdvancedSection.jsx
import React from "react";
import IncomeAdvanced from "./IncomeAdvanced";

export default function IncomeAdvancedSection(props) {
  // Advanced Income Approach saves under data.income_advanced
  return <IncomeAdvanced {...props} dataKey="income_advanced" />;
}
